<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.BRFNoFilter ||
              Filter.enqNoFilter ||
              Filter.vesselNameFilter ||
              Filter.vesselVoyageFilter ||
              Filter.vesselSailDateFilter ||
              Filter.fk_contract_id ||
              Filter.fk_ccbm_id ||
              Filter.contractNoFilter ||
              Filter.serach_txt ||
              Filter.slineFilter ||
              Filter.clientFilter ||
              Filter.createdByFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.BRFNoFilter ||
                  Filter.enqNoFilter ||
                  Filter.vesselNameFilter ||
                  Filter.vesselVoyageFilter ||
                  Filter.vesselSailDateFilter ||
                  Filter.fk_contract_id ||
                  Filter.fk_ccbm_id ||
                  Filter.contractNoFilter ||
                  Filter.serach_txt ||
                  Filter.slineFilter ||
                  Filter.clientFilter ||
                  Filter.createdByFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getBookingResp.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getBookingResp', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <b-col cols="6"> </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getBookingRespDash('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>BRF NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search BRF NO Filter"
                    id="BRFNoFilter" name="BRFNoFilter" autocomplete="off" v-model="Filter.BRFNoFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Enq NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Enq NO Filter"
                    id="enqNoFilter" name="enqNoFilter" autocomplete="off" v-model="Filter.enqNoFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Vessel Name Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Vessel Name Filter"
                    id="vesselNameFilter" name="vesselNameFilter" autocomplete="off" v-model="Filter.vesselNameFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Voyage No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Voyage No Filter"
                    id="vesselVoyageFilter" name="vesselVoyageFilter" autocomplete="off"
                    v-model="Filter.vesselVoyageFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Vessel Sail Date Filter</label>
                  <b-form-input type="date" :formatter="capitalizeAll" placeholder="Search Vessel Sail Date Filter"
                    id="vesselSailDateFilter" name="vesselSailDateFilter" autocomplete="off"
                    v-model="Filter.vesselSailDateFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Contract No</label>
                  <model-list-select class="ml-1" :list="$store.getters['common/getAllContractList']" id="fk_contract_id"
                    v-model="Filter.fk_contract_id" option-value="value" option-text="label"
                    placeholder="Select Contract NUMBER"
                    @input="getContractNoBasedVessel(Filter.fk_contract_id); getBrfAnalysisList('Normal', '0', '0', '1', '1')" />
                  <!-- <label>Contract No Filter</label> -->
                  <!-- <b-form-input type="text" :formatter="capitalizeAll" placeholder="Contract Voyage No Filter"
                    id="contractNoFilter" name="contractNoFilter" autocomplete="off" v-model="Filter.contractNoFilter"
                    @input="getContractNoBasedVessel(Filter.contract_no);getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input> -->
                </b-col>
                <b-col md="2">
                  <label for="blType">Vessel Name :</label>
                  <model-list-select class="ml-1" :list="$store.getters['common/getAllContractBasedVesselList']"
                    id="vessel_name" v-model="Filter.fk_ccbm_id" option-value="value" option-text="label"
                    placeholder="Select Vessel Name" @input="getBookingRespDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="serach_txt" name="serach_txt" autocomplete="off" v-model="Filter.serach_txt"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>


                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getBookingRespDash('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName"
                    placeholder="Select Created User"></model-list-select>
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">

          <div class="col-md-12">
            <input type="checkbox" @click="SelectAll(getBookingResp)" v-model="isCheckAll" />
            <label>Select / Deselect All Count({{ this.brcm_ids.length }})</label>
            <b-button v-if="brcm_ids.length > 0" size="sm" @click="ProceedMultiBRFRate" variant="outline-primary">Multi
              Update</b-button>
          </div>
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">

              <b-table show-empty stacked="md" responsive :items="getBookingResp" :fields="BookingEditorFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">
                <template slot="SN" slot-scope="row0">
                  <input type="checkbox" v-bind:value="row0.item.brcm_id" v-model="brcm_ids"
                    @change="updateSelectAll($event, row0.item)" />

                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>
                <template slot="BrfNo" slot-scope="row1">
                  <span v-if="row1.item.BrfNo">BRF No : {{ row1.item.BrfNo }}<br /></span>
                  <b-form-input class="w-100" v-if="row1.item.isEditing" v-model="editingRowData.brcm_rate"
                    @keydown.native.stop />
                  <span v-else>{{ row1.item.brcm_rate }}</span>
                  <!-- <span v-if="row1.item.CreatedBy">Created By : {{ row1.item.CreatedBy }}<br /></span>
                  <span v-if="row1.item.CreatedBy">Created At : {{ row1.item.CreatedAt }}<br /></span>
                  <span v-if="row1.item.CreatedBy">Updated By : {{ row1.item.UpdatedBy }}<br /></span>
                  <span v-if="row1.item.CreatedBy">Updated At : {{ row1.item.UpdatedAt }}<br /></span> -->
                </template>
                <template slot="Client" slot-scope="row1">
                  <span v-if="row1.item.Client">Shipper : {{ row1.item.Client }}<br /></span>
                  <b-form-input class="w-100" v-if="row1.item.isEditing" v-model="editingRowData.brcm_sell_rate"
                    @keydown.native.stop />
                  <span v-else>{{ row1.item.brcm_sell_rate }}</span>
                </template>
                <template slot="Sline" slot-scope="row1">
                  <span v-if="row1.item.Sline">Sline : {{ row1.item.Sline }}<br /></span>
                  <div class="d-flex">
                    <b-button style="font-size: 0.675rem" size="sm" class="mr-2" variant="outline-primary"
                      @click="getBRFPricingLog(row1.item)">
                      Log
                    </b-button>

                    <b-button style="font-size: 0.675rem" size="sm" variant="outline-primary"
                      @click="startEditing(row1.item)">
                      Edit
                    </b-button>
                    <b-button style="font-size: 0.675rem" v-if="row1.item.isEditing" size="sm" variant="success"
                      class="ml-2" @click="saveRow(row1.item)">
                      Save
                    </b-button>
                    <b-button style="font-size: 0.675rem" v-if="row1.item.isEditing" size="sm" variant="danger"
                      class="ml-2" @click="cancelEdit(row1.item)">
                      Cancel
                    </b-button>
                  </div>
                </template>
                <!-- <template slot="brcm_rate" slot-scope="row1">
                  <b-form-input class="w-100" v-if="row1.item.isEditing" v-model="editingRowData.brcm_rate"
                    @keydown.native.stop />
                  <span v-else>{{ row1.item.brcm_rate }}</span>

                </template>
                <template slot="brcm_sell_rate" slot-scope="row1">
                  <b-form-input class="w-100" v-if="row1.item.isEditing" v-model="editingRowData.brcm_sell_rate"
                    @keydown.native.stop />
                  <span v-else>{{ row1.item.brcm_sell_rate }}</span>

                </template> -->

                <template slot="action" slot-scope="row1">

                  <ToggleBRFSwitch v-if="row1.item.pricing_booking_resp_map_relation.prbr_id > 0 && row1.item.console_booking_response_relation.booking_id > 0"
                    :brf_no="row1.item.pricing_booking_resp_map_relation.enquiry_booking_no" :booking_no="row1.item.console_booking_response_relation.booking_no"
                    :booking_id="row1.item.console_booking_response_relation.booking_id" :prbr_id="row1.item.pricing_booking_resp_map_relation.prbr_id"
                    :isbookingactive="row1.item.console_booking_response_relation.isbookingactive" :prbr_is_active="row1.item.pricing_booking_resp_map_relation.prbr_is_active"
                    :request_type="'BRFEditor'" @success="getBookingRespDash" />

                  <BRFCard v-if="row1.item.fk_prbr_id > 0" :BRFDetails="row1.item"
                    :prbr_id="Number(row1.item.fk_prbr_id)" />
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <b-modal id="viewBRFDetails-modal" ref="viewBRFDetails-modal" :title="'BRF Rate Log Details-' + BRFNo" size="xl"
      no-close-on-esc no-close-on-backdrop hide-footer>
      <b-row>
        <b-col md="12">
          <b-table :items="BrfBookingList" :fields="BrfBookingColumn" small responsive head-variant="light">
            <template slot="SN" slot-scope="row0"><span>{{ row0.item.SN }}</span></template>
          </b-table>
        </b-col>
      </b-row>
      <b-button @click="hideviewBRFDetails" variant="danger" class="pull-right btn-sm mt-2">
        Close</b-button>
    </b-modal>

    <b-modal id="Multi-BRF-Modal" ref="Multi-BRF-Modal" title="Multi BRF Rate Editor" centered no-close-on-esc
      no-close-on-backdrop hide-footer>
      <b-row>
        <b-col cols="12">
          <label>
            Buy Rate
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" name="brcm_rate" id="brcm_rate" v-model="MultiBRF.brcm_rate"
            type="text" />
          <span class="error" v-if="!MultiBRF.brcm_rate">
            {{ errorMultiBRF.brcm_rate }}
          </span>
        </b-col>
        <b-col cols="12">
          <label>
            Sell Rate
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" name="brcm_sell_rate" id="brcm_sell_rate"
            v-model="MultiBRF.brcm_sell_rate" type="text" />
          <span class="error" v-if="!MultiBRF.brcm_sell_rate ? true : false">
            {{ errorMultiBRF.brcm_sell_rate }}
          </span>

        </b-col>
      </b-row>
      <b-row class="mt-2 flex">
        <b-col cols="12">
          <b-button :disabled="((MultiBRF.brcm_rate || MultiBRF.brcm_sell_rate) && brcm_ids.length > 0) ? false : true"
            class="sm" variant="success" @click="PayMultiBRF">Proceed</b-button>
          <b-button @click="closeMultiBRFModal" variant="danger" class="pull-right sm">Close</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop" />
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import BRFCard from "../common/brfCard.vue";
import ToggleBRFSwitch from "./ToggleBRFSwitch.vue";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({ itemCode: "ContainerTypeList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),

      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),
      this.$store.dispatch("common/setAllContractList", {
        filter: "ContractList",
        active: "all",
        isAll: 1,
        cb_is_active: 1,
        cb_is_deleted: 0,
        isSelectedColumn: 1,
      }),
      this.$store.dispatch("common/setAllContractBasedVesselList", {
        filter: "ContractVesselList",
        active: "all",
        isAll: 0,
        ccbm_is_active: 1,
        ccbm_is_deleted: 0,
        isSelectedColumn: 0,
        // isSelectedColumn: 1,
        fk_cb_id: 0,
        is_withoutcb: 1,
      }),
    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(1000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function
        this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
        this.getCurrentLastDate();

        if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
          this.fetchLastPage(this.lastVisitPage);
        } else {
          this.getBookingRespDash("Normal", "0", "0", "1", "1");
        }
      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });


  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      isCheckAll: false,
      brcm_ids: [],
      MultiBRF: {
        brcm_ids: [],
        brcm_rate: "",
        brcm_sell_rate: "",
      },
      errorMultiBRF: {
        brcm_rate: "",
        brcm_sell_rate: "",
      },

      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      BrfBookingList: [],
      BrfBookingColumn: [
        { key: 'SN', label: 'SN' },
        { key: 'log_id', label: 'Log ID' },
        { key: 'field_name', label: 'Column' },
        { key: 'old_value', label: 'Old Value' },
        { key: 'new_value', label: 'New Value' },
        { key: 'CreatedBy', label: 'Created By' },
        { key: 'CreatedAt', label: 'Created At' },
      ],
      getBookingResp: [],
      totalData: 0,
      editingRowId: null,
      editingRowData: {},
      BookingEditorFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
          tdClass: 'text-nowrap'
        },
        {
          key: "BrfNo",
          mainkey: "BrfNo",
          label: "Brf No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "Client",
          mainkey: "Client",
          label: "Shipper",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "Sline",
          mainkey: "Sline",
          label: "Sline",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "POR",
          mainkey: "POR",
          label: "POR",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "POL",
          mainkey: "POL",
          label: "POL",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "POD",
          mainkey: "POD",
          label: "POD",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "ContainerType",
          mainkey: "ContainerType",
          label: "Equipment Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "ContractNo",
          mainkey: "ContractNo",
          label: "Contract No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "VesselName",
          mainkey: "VesselName",
          label: "Vessel Name",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        {
          key: "VoyageNo",
          mainkey: "VoyageNo",
          label: "Voyage No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
        // {
        //   key: "brcm_rate",
        //   mainkey: "brcm_rate",
        //   label: "Buy Rate",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        //   tdClass: 'text-nowrap'
        // },
        // {
        //   key: "brcm_sell_rate",
        //   mainkey: "brcm_sell_rate",
        //   label: "Sell Rate",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        //   tdClass: 'text-nowrap'
        // },

        // {
        //   key: "CreatedBy",
        //   mainkey: "CreatedBy",
        //   label: "Created By",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "CreatedAt",
        //   mainkey: "CreatedAt",
        //   label: "Created At",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "UpdatedBy",
        //   mainkey: "UpdatedBy",
        //   label: "Updated By",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "UpdatedAt",
        //   mainkey: "UpdatedAt",
        //   label: "Updated At",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        {
          key: "action",
          mainkey: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'text-nowrap'
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {
        BRFNoFilter: "",
        enqNoFilter: "",
        vesselNameFilter: "",
        vesselVoyageFilter: "",
        vesselSailDateFilter: "",
        fk_contract_id: "",
        fk_ccbm_id: "",
        contractNoFilter: "",
        createdByFilter: "",
        serach_txt: "",
        slineFilter: "",
        clientFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      isSubmited: false,
      BRFNo: "",
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
    BRFCard,
    ToggleBRFSwitch,
  },
  computed: {},
  watch: {},
  methods: {
    getContractNoBasedVessel(fk_contract_idFilter) {
      this.$store.dispatch("common/setAllContractBasedVesselList", {
        filter: "ContractVesselList",
        active: "all",
        isAll: 0,
        ccbm_is_active: 1,
        ccbm_is_deleted: 0,
        isSelectedColumn: 0,
        // isSelectedColumn: 1,
        fk_cb_id: fk_contract_idFilter,
        is_withoutcb: 1,
      });
    },
    SelectAll: function () {
      console.log('SelectAll item=>');
      this.isCheckAll = !this.isCheckAll;
      this.brcm_ids = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.getBookingResp) {
          if (this.getBookingResp[key].brcm_id) {
            this.brcm_ids.push(this.getBookingResp[key].brcm_id);
          }
        }
      }
    },
    updateSelectAll: function (e, item) {
      console.log('updateSelectAll item=>', item);
      if (this.brcm_ids.length == this.getBookingResp.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      this.brcm_ids.push(item.brcm_id);
      const istrue = this.brcm_ids.includes(item.brcm_id);
      if (istrue == true) {
        const index = this.brcm_ids.indexOf(item.brcm_id);
        this.brcm_ids.splice(index, 1);
      }
    },
    ProceedMultiBRFRate() {
      this.$refs["Multi-BRF-Modal"].show();
    },
    closeMultiBRFModal() {
      this.$refs["Multi-BRF-Modal"].hide();
    },
    PayMultiBRF() {
      if (this.brcm_ids.length > 0) {
        let payload = {
          brcm_ids: this.brcm_ids,
          brcm_rate: this.MultiBRF.brcm_rate,
          brcm_sell_rate: this.MultiBRF.brcm_sell_rate
        };
        // TODO: Save to server
        NodeLockPannelService.updateMultipleBRCMWithLogging(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              console.log('saveRow data=>', data)
              this.alert.content = data.message;
              this.$refs["addPop"].open();
              this.getBookingRespDash("Normal", "0", "0", "1", "1");
              this.closeMultiBRFModal();
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on saveRow Error: ", error);
          });
      } else {
        this.alert.content = "Please select at least one BRF to proceed with this action.";
        this.$refs["addPop"].open();
      }
    },

    getBRFPricingLog(item) {
      this.BRFNo = item.BrfNo;
      this.getBRFBookingLogDetails(item.brcm_id);
      this.$refs["viewBRFDetails-modal"].show();
    },
    hideviewBRFDetails() {
      this.BRFNo = "";
      this.$refs["viewBRFDetails-modal"].hide();
    },
    getBRFBookingLogDetails(brcm_id) {
      let payload = {
        brcm_id: brcm_id,
        isAll: 1,
      }
      try {
        NodeLockPannelService.getBRCMWithLogging(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log('BrfBookingList', data)
            if (status == 200 && data) {
              this.BrfBookingList = data.data;
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isSubmited = false;
            console.log("Catch on getBRFBookingLogDetails Error: ", error);
          });

      } catch (error) {
        console.error("Error updating getBRFBookingLogDetails:", error);
      }
    },
    startEditing(item) {
      this.editingRowId = item.brcm_id;
      this.editingRowData = JSON.parse(JSON.stringify(item));
      this.$set(item, "isEditing", true);
    },
    cancelEdit(item) {
      this.editingRowId = null;
      this.editingRowData = {};
      this.$set(item, "isEditing", false);
    },
    saveRow(item) {
      Object.assign(item, this.editingRowData);
      this.editingRowId = null;
      this.editingRowData = {};
      this.$set(item, "isEditing", false);

      console.log("Saved:", item);
      // TODO: Save to server
      NodeLockPannelService.updateBRCMWithLogging(item)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.alert.content = data.message;
            this.$refs["addPop"].open();
            console.log('saveRow data=>', data)
            this.getBookingRespDash("Normal", "0", "0", "1", "1");
            this.hideviewBRFDetails();
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on saveRow Error: ", error);
        });
    },
    clearFilter() {
      this.Filter = {
        BRFNoFilter: "",
        enqNoFilter: "",
        vesselNameFilter: "",
        vesselVoyageFilter: "",
        vesselSailDateFilter: "",
        fk_contract_id: "",
        fk_ccbm_id: "",
        contractNoFilter: "",
        createdByFilter: "",
        serach_txt: "",
        slineFilter: "",
        clientFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getBookingRespDash("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getBookingRespDash(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.totalData = 0;
      this.getBookingResp = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getBookingResp",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        searach_txt: this.Filter.serach_txt,
        generateExcel: this.generateExcel,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getBookingRespEditor(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data.data);
          if (status == 200 && data) {
            if (this.generateExcel == "1") {

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "BRFEditorData.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getBookingRespDash("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalCounts;
                this.getBookingResp = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getBookingRespDash("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getBookingRespDash("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBookingRespDash("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getBookingRespDash("Normal", "0", CURRENT, "2", event);
    },
  },
};

</script>

<style scoped>
.no-wrap td,
.no-wrap th {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// bookingRespDashEdit.vue?0a2910a0